var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{style:('border-left: 6px ridge ' + _vm.currentCategory().color)},[_vm._v("\n  "+_vm._s(_vm.currentCategory().description || '相关话题（已关闭的话题不在搜索范围）')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }